export default __webpack_public_path__ + "static/media/loading.447a65d4.png";